import { z } from 'zod'
import { isNotificationChannelAvailable, NOTIFICATION_CHANNELS } from '../constants/training-enums'

/** 設定できる通知チャネル（enum に存在しても、未提供のチャネルは拒否する） */
export const SettableNotificationChannelSchema = z
  .enum(NOTIFICATION_CHANNELS)
  .refine(isNotificationChannelAvailable, {
    message: 'メール通知は現在ご利用いただけません。Teams を選択してください。',
  })
